// Super Admin (God Mode) dashboard.
// Hard gate: route is only reachable for info@noordzuid.nl AND after TOTP has
// been verified in this browser (short-lived SA token). All other users get a
// 404-style "page not found" so the panel's existence stays private.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import TotpGate from "@/components/super-admin/TotpGate";
import SuperAdminLayout from "@/components/super-admin/SuperAdminLayout";

const SUPER_ADMIN_EMAIL = "info@noordzuid.nl";

export default function SuperAdmin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [checking, setChecking] = useState(true);

  const refreshStatus = async () => {
    try {
      const { data } = await api.get("/super-admin/status");
      setStatus(data);
    } catch {
      setStatus({ is_super_admin: false });
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login", { replace: true });
      return;
    }
    if ((user.email || "").toLowerCase() !== SUPER_ADMIN_EMAIL) {
      // Mimic 404 without actually bouncing — keeps route "quiet".
      setStatus({ is_super_admin: false });
      setChecking(false);
      return;
    }
    refreshStatus();
  }, [user, loading, navigate]);

  if (loading || checking) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-gray-500">Laden…</div>;
  }

  if (!status?.is_super_admin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white px-6">
        <div className="max-w-md text-center">
          <div className="text-[11px] uppercase tracking-widest text-gray-400 mb-3">404</div>
          <h1 className="font-display text-3xl font-medium text-[#1a1a1a] mb-3">Pagina niet gevonden</h1>
          <p className="text-sm text-gray-500">De URL die je probeerde te openen bestaat niet of je hebt er geen toegang toe.</p>
        </div>
      </div>
    );
  }

  if (!status.sa_session_active) {
    return <TotpGate status={status} onSuccess={refreshStatus} />;
  }

  return <SuperAdminLayout />;
}
